// 海報牆的列（純函式）：把「段落標題＋遊戲」切成固定欄數的列，虛擬清單以列為單位繪製，
// 清單再長，畫面上的元素數量也固定。清單版面等於一列一款。
import type { CatalogItem, ListEntry, SectionHeader } from './catalog.ts';

export type Row =
  | { kind: 'header'; key: string; header: SectionHeader }
  | { kind: 'row'; key: string; section: string; items: CatalogItem[] };

export function toRows(entries: readonly ListEntry[], columns: number): Row[] {
  const cols = Math.max(1, Math.floor(columns));
  const out: Row[] = [];
  let current: Extract<Row, { kind: 'row' }> | null = null;
  for (const e of entries) {
    if (e.kind === 'header') {
      out.push({ kind: 'header', key: `h:${e.key}`, header: e });
      current = null;
      continue;
    }
    if (!current || current.items.length >= cols || current.section !== e.section) {
      current = { kind: 'row', key: `r:${e.key}`, section: e.section, items: [] };
      out.push(current);
    }
    current.items.push(e.item);
  }
  return out;
}

/** 海報最小寬度與間距（與 CSS 一致） */
export const POSTER_MIN = 148;
export const POSTER_GAP = 18;

/**
 * 欄數：手機 2 欄、平板 3–4 欄、桌面 5–7 欄（依可用寬度），清單版面 1 欄。
 * `width` 是海報區的實際寬度（桌面扣掉左欄的段落標題）。
 */
export function columnsFor(width: number, layout: 'grid' | 'list', viewport: number): number {
  if (layout === 'list') return 1;
  if (viewport < 640) return 2;
  const fit = Math.floor((width + POSTER_GAP) / (POSTER_MIN + POSTER_GAP));
  const [min, max] = viewport < 1024 ? [3, 4] : [5, 7];
  return Math.min(max, Math.max(min, fit));
}
